// Module
var code = `<div id="customer-loans">
    <table class="table" at-table at-list="\$ctrl.loans">
      <thead></thead>
      <tbody class="tbody">
      <tr>
        <td at-title="No">
          {{\$index+1}}
        </td>
        <td at-title="Customer name">{{item.customer.effectiveName}}</td>
        <td at-title="Product name">{{item.loanType.productDefinition.productName}}</td>
        <td at-title="Product number">{{item.productNumber}}</td>
        <td at-title="Status">{{item.status}}</td>
        <td at-title="Outstanding principal">{{item.principalBalance | nxCurrency}}</td>
        <td at-title="Outstanding due">{{item.amortizationSchedule.totalBalance.totalDue | nxCurrency}}</td>
        <td at-title="Total principal">{{item.principalAmount | nxCurrency}}</td>
        <td at-title="Date granted">{{item.grantDate | prettyDate}}</td>
        <td at-title="Maturity date">{{item.maturityDate | prettyDate}}</td>
        <td at-title="&nbsp;">
          <button type="button"
                  class="btn btn-primary"
                  permissions = 'CST_EMPLOYEE_LOANS_READ'
                  permission-context="{customerId: item.customerId, loanId: item.id}"
                  ng-click="\$ctrl.openLoan(item)">Open</button>
        </td>
      </tr>
      </tbody>
    </table>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/group-loans/loans/individual/batch-loans-individual.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;